










































































































































































































import Vue from "vue";
import Processing from "@/components/table/Processing.vue";
import Modal from "@/components/root/modal/Modal.vue";
import { ModalConfig } from "@/components/root/modal";
import { UseLoading } from "@/common/composition/loading";
import { state } from "./data/state";
import {
  computed,
  onBeforeUnmount,
  onMounted,
  Ref,
  ref,
  watch,
} from "@vue/composition-api";
import { get_full_script } from "./data/api";
import { AppScript } from "./data/models";
import ScriptSentence from "./ScriptSentence.vue";
import { CopyUrl } from "@/common/clipboard";

// @ts-ignore
import { ScriptJobManager } from "./data/script-job.manager";
import { emptyFn, uniq } from "@/fp";
import { CLOUD_SCRIPTS } from "./data/cloud.scripts";
import EmbedHtml from "@/components/EmbedHtml.vue";

export default Vue.extend({
  components: {
    Modal,
    Processing,
    ScriptSentence,
    EmbedHtml,
  },
  props: ["modalData"],
  setup(props) {
    const config: ModalConfig = {
      title: "",
      desc: "",
      blank: true,
      width: "105rem",
      height: "70rem",
      withTopRightCloseBtn: true,
    };

    const script_desc_points = computed(() => {
      // @ts-ignore
      if (props.modalData?.type === "cloud") {
        return [
          `<b> Download</b> the .csv file by clicking it`,
          `<b>Edit</b> it to fit your needs`,
          `<b>Upload</b> it using the below section`,
          `<b>Hit Run</b> to exec the presented script in the cloud on the attached .csv`,
        ];
      } else {
        return [
          `<b> Download</b> the .csv and .ps1 files by clicking each one`,
          `write down the location of each .csv file`,
          `<b>Paste</b> the location of the files as the input for the csv
                in the script`,
        ];
      }
    });

    const script_vars_el: Ref<{
      get_vars: () => Record<string, string>;
      set_vars: (vars: Record<string, string>) => void;
    } | null> = ref(null);

    const files: Ref<{
      file_name: string;
      download_fn: () => void;
    }[]> = ref([]);

    const status = ref("idle");

    const script: Ref<AppScript | null> = ref(null);

    const threats = computed(() => {
      if (script.value) {
        return uniq([
          ...script.value.threats,
          ...script.value.cascading_threats,
        ]);
      } else {
        return [];
      }
    });

    const { template_vars } = state;

    const [is_loading, set_loading] = UseLoading(true).as_arr();

    let stored_vars = {};
    const generate_script = async () => {
      let vars = script_vars_el.value!.get_vars();
      stored_vars = vars;
      // @ts-ignore
      if (props.modalData.hack_map) {
        // @ts-ignore
        vars = props.modalData.hack_map(vars);
      }
      console.log("vars::", vars);
      const [success, remove_sub] = await ScriptJobManager.create_job(
        script.value!,
        vars,
        function listener(
          job_status: string,
          items: Array<{
            file_name: string;
            download_fn: () => void;
          }>
        ) {
          status.value = job_status;
          if (items) {
            files.value = items;
          }
        }
      );

      status.value = success ? "in-progress" : "failure";
      subs.gen_script_listener = remove_sub;
      // @ts-ignore
      //  highlight();
    };

    const copy_script = () => {
      CopyUrl(script.value?.script, "Script was copy to clipboard");
      // highlight();
    };

    const csv_file_to_upload: Ref<File | null> = ref(null);
    const on_file_uploaded = (files: File[] = []) => {
      console.log("on_file_uploaded : ", files);
      if (files.length > 0) {
        csv_file_to_upload.value = files[0];
      }
    };

    const run_script_on_the_cloud = async () => {
      CLOUD_SCRIPTS[script.value!.id](stored_vars);
    };

    const subs = {
      gen_script_listener: emptyFn(),
    };

    onMounted(async () => {
      const { id: script_id, vars, type = "powershell" } = props.modalData as {
        // script id
        id: string;
        // script template variants (optional)
        vars?: Record<string, string>;
        type: "cloud" | "powershell";
      };

      if (vars) {
        // wait for the SentenceEl to mount and
        // then set the vars
        const unsub = watch(script_vars_el, (new_val) => {
          if (new_val) {
            new_val.set_vars(vars);
            unsub();
          }
        });
      }

      const res = await get_full_script(script_id);
      if (res.success) {
        script.value = res.value;
      }

      set_loading(false);
    });

    onBeforeUnmount(() => Object.values(subs).forEach((unsub) => unsub()));

    return {
      config,
      script_desc_points,
      threats,
      script_vars_el,
      is_loading,
      status,
      generate_script,
      script,
      template_vars,
      files,
      copy_script,
      on_file_uploaded,
      csv_file_to_upload,
      run_script_on_the_cloud,
    };
  },
});
